export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [3,[2]],
		"/(app)/announcement/lists": [4,[2]],
		"/(app)/announcement/registries": [5,[2]],
		"/(app)/asset/categories": [6,[2]],
		"/(app)/asset/registries": [7,[2]],
		"/(app)/facility/categories": [8,[2]],
		"/(app)/facility/registries": [9,[2]],
		"/(auth)/login": [28],
		"/(app)/maintenance/inspections": [10,[2]],
		"/(app)/maintenance/schedules": [11,[2]],
		"/(app)/member/profile": [12,[2]],
		"/(app)/member/reservations": [13,[2]],
		"/(app)/member/settings": [14,[2]],
		"/(app)/personnel/attendances": [15,[2]],
		"/(app)/personnel/monthly-shifts": [16,[2]],
		"/(app)/personnel/roles": [17,[2]],
		"/(app)/personnel/shifts": [18,[2]],
		"/(app)/personnel/users": [19,[2]],
		"/(app)/service/booking": [20,[2]],
		"/(app)/service/staff-ratings": [21,[2]],
		"/(app)/site/estates": [22,[2]],
		"/(app)/site/profile": [23,[2]],
		"/(app)/space/registries": [24,[2]],
		"/(app)/space/reservations": [25,[2]],
		"/(app)/vendor/categories": [26,[2]],
		"/(app)/vendor/registries": [27,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';